// extracted by mini-css-extract-plugin
export default {"container":"SwipeableScreen_container__kF5VA","arrow":"SwipeableScreen_arrow__agDhk","arrowLeft":"SwipeableScreen_arrowLeft__jBA9e","arrowRight":"SwipeableScreen_arrowRight__Ng0SX"};